import React from "react";

import PropTypes from "prop-types";

const EMPTY_ARRAY = [];
const NOOP_RENDER = () => null;

const RenderContent = (props) => {
  if (!props.beneficiaries.length) {
    return <props.renderEmpty {...props} />;
  }
  return (
    <>
      {props.beneficiaries.map((beneficiary) => (
        <props.renderBeneficiary
          beneficiary={beneficiary}
          key={beneficiary.value}
          {...props}
        />
      ))}
    </>
  );
};
RenderContent.propTypes = {
  beneficiaries: PropTypes.array,
};

export default function BeneficiaryList({
  beneficiaries = EMPTY_ARRAY,
  renderEmpty = NOOP_RENDER,
  ...props
}) {
  return (
    <>
      <RenderContent
        beneficiaries={beneficiaries}
        renderEmpty={renderEmpty}
        {...props}
      />
    </>
  );
}

BeneficiaryList.propTypes = {
  beneficiaries: PropTypes.array,
  renderBeneficiary: PropTypes.func.isRequired,
  renderEmpty: PropTypes.func,
};
